import { AlertService } from '@/services/alert.service';
import { AuthenticationService } from '@/services/authentication.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLinkActive, RouterLink } from '@angular/router';
import { UsersService } from '@eemo/api-client';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-email-validation',
    templateUrl: './email-validation.component.html',
    styleUrls: ['./email-validation.component.scss'],
    standalone: true,
    imports: [MatButtonModule, RouterLinkActive, RouterLink, MatIconModule]
})
export class EmailValidationComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userService: UsersService,
    private alertService: AlertService,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      const userId = params.get('uid');
      const key = params.get('key');
      if (!userId && !key) {
        this.alertService.error('Paramètres invalides');
        return;
      }
      this.userService.validateUserEmail(userId, key).subscribe((result) => {
        this.alertService.success('Votre adresse email est validée !');
        if (this.authenticationService.currentUserValue) {
          this.authenticationService.validateUserEmail();
          this.redirectToHome();
        }
      });
    });
  }

  redirectToHome() {
    this.router.navigate(['/home']);
  }
}
